import { createContext, FC, memo, PropsWithChildren, useContext } from 'react';

const currentOfficeIdContext = createContext<string | undefined>(undefined);

type Props = {
  currentOfficeId: string | undefined;
};

export const CurrentOfficeIdProvider: FC<PropsWithChildren<Props>> = memo(
  ({ children, currentOfficeId }) => {
    return (
      <currentOfficeIdContext.Provider value={currentOfficeId}>
        {children}
      </currentOfficeIdContext.Provider>
    );
  }
);
CurrentOfficeIdProvider.displayName = 'CurrentOfficeIdProvider';

export const useCurrentOfficeId = () => useContext(currentOfficeIdContext);
